import { IonPage } from '@ionic/react'

import { UnitCreateMultipleView } from '@apps-common/apps/portal/pages/units/pages/create-multiple/components'
import { UnauthorizedCard } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_CREATE_MULTIPLE_UNIT } from '@apps-radionet-portal-root/src/config/private-routes'

export const UnitCreateMultiplePage = () => {
  const t = ''

  return (
    <IonPage>
      <Header>
        <Navbar showBack transparent />
        <Breadcrumbs route={ROUTE_CREATE_MULTIPLE_UNIT} />
        <div className='flex items-center justify-between max-w-[1200px]'>
          <PageTitle classes='flex items-center justify-start gap-[5px]'>
            <span>Create Multiple</span>
          </PageTitle>
          <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}></Authorization>
        </div>
      </Header>
      <LayoutContainer>
        <LayoutPadding>
          <Authorization
            roles={AUTH_CLAIMS.managementAdmin.roles}
            scopes={AUTH_CLAIMS.managementAdmin.scopes}
            notAuthorizedFallback={<UnauthorizedCard />}
          >
            <UnitCreateMultipleView />
          </Authorization>
        </LayoutPadding>
      </LayoutContainer>
    </IonPage>
  )
}
